export default __webpack_public_path__ + "static/media/la_capelle.7ffc4de5.jpg";